import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Coins, Star } from "lucide-react";

export default function MysteryPage() {
  const [busy, setBusy] = useState(false);
  const [fact, setFact] = useState(null);

  const roll = async () => {
    setBusy(true);
    try {
      const r = await api.post("/scans/mystery");
      setFact(r.data);
      toast.success(`+${r.data.reward_coins} Coins · +${r.data.reward_xp} XP`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Try again");
    } finally { setBusy(false); }
  };

  useEffect(() => {}, []);

  return (
    <div className="min-h-screen pb-28 pt-6 px-4 max-w-md mx-auto jx-grid-bg">
      <h1 className="font-heading text-3xl font-bold">Mystery Button</h1>
      <p className="text-slate-400 text-sm">A tiny surprise from Jixxeo AI — a fact, a trivia, or a scanning challenge.</p>

      <div className="mt-6 jx-glass rounded-3xl p-5 min-h-[220px] flex flex-col items-center justify-center">
        {fact ? (
          <div className="text-center jx-fade-up">
            <p className="text-[11px] font-mono-data uppercase tracking-widest text-cyan-300">{fact.kind}</p>
            <h2 className="mt-2 font-heading text-2xl font-bold" data-testid="mystery-title">{fact.title}</h2>
            <p className="mt-2 text-slate-300 text-sm">{fact.body}</p>
            <div className="mt-4 flex items-center justify-center gap-3 text-xs font-mono-data uppercase text-slate-400">
              <span className="inline-flex items-center gap-1"><Coins size={14} className="text-amber-300" /> {fact.reward_coins}</span>
              <span className="inline-flex items-center gap-1"><Star size={14} className="text-cyan-300" /> {fact.reward_xp} XP</span>
            </div>
          </div>
        ) : (
          <div className="text-center text-slate-400">
            <Sparkles className="mx-auto text-cyan-300" size={30} />
            <p className="mt-2 text-sm">Tap the button to reveal a mystery.</p>
          </div>
        )}
      </div>

      <button
        data-testid="mystery-roll-button"
        onClick={roll}
        disabled={busy}
        className="mt-6 w-full h-14 rounded-2xl bg-cyan-400 text-slate-950 font-heading font-bold text-lg active:scale-95 disabled:opacity-70"
      >
        {busy ? "Rolling…" : "Reveal a mystery"}
      </button>
    </div>
  );
}
